import React from 'react';
import Icon from '../../../components/AppIcon';

const AdherenceTracker = ({ adherenceData }) => {
  const getAdherenceColor = (percentage) => {
    if (percentage >= 90) return 'text-success';
    if (percentage >= 70) return 'text-warning';
    return 'text-destructive';
  };

  const getAdherenceBarColor = (percentage) => {
    if (percentage >= 90) return 'bg-success';
    if (percentage >= 70) return 'bg-warning';
    return 'bg-destructive';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">Medication Adherence</h2>
          <p className="text-sm text-muted-foreground">Patient compliance tracking</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-muted rounded-lg p-4 text-center">
          <p className="text-sm text-muted-foreground mb-2">Overall Adherence</p>
          <p className={`text-3xl font-bold ${getAdherenceColor(adherenceData?.overall)}`}>
            {adherenceData?.overall}%
          </p>
        </div>
        <div className="bg-muted rounded-lg p-4 text-center">
          <p className="text-sm text-muted-foreground mb-2">Last 30 Days</p>
          <p className={`text-3xl font-bold ${getAdherenceColor(adherenceData?.last30Days)}`}>
            {adherenceData?.last30Days}%
          </p>
        </div>
        <div className="bg-muted rounded-lg p-4 text-center">
          <p className="text-sm text-muted-foreground mb-2">Missed Doses</p>
          <p className="text-3xl font-bold text-destructive">
            {adherenceData?.missedDoses}
          </p>
        </div>
      </div>
      <div className="space-y-4">
        <h3 className="text-sm font-semibold text-foreground">Medication-Specific Adherence</h3>
        {adherenceData?.medications?.map((med, index) => (
          <div key={index} className="bg-muted rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{med?.name}</p>
                <p className="text-xs text-muted-foreground">{med?.dosage}</p>
              </div>
              <span className={`text-lg font-bold ${getAdherenceColor(med?.adherence)}`}>
                {med?.adherence}%
              </span>
            </div>
            <div className="w-full bg-background rounded-full h-2 overflow-hidden">
              <div
                className={`h-full ${getAdherenceBarColor(med?.adherence)} transition-all duration-500`}
                style={{ width: `${med?.adherence}%` }}
              />
            </div>
            <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground">
              <span>Last refill: {med?.lastRefill}</span>
              <span>Next refill: {med?.nextRefill}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdherenceTracker;